import ThemeContext from "config/context/themeContext";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import styles from "./MainLayout.module.css";
import { MainNavbar, MainSidebar } from "features/navigation";
import { DatabaseStructureFetcher } from "features/compositions";
import { CompositionsContextProvider } from "features/compositions/context/CompositionsContext";
import { MemoryContextProvider } from "features/memory";
import ModalRenderer from "components/shared/modal/ModalRenderer.jsx";

const MainLayout = () => {
  const { dark: isDark } = useContext(ThemeContext);

  // `MemoryContextProvider` je od 06.10.2026. ovde, a ne u `UserGUI`.
  //
  // Widget koji zauzeće PRIKAZUJE živi u `UserGUI`, a radnje koje ga MENJAJU —
  // brisanje baze, uvoz, drop kompozicije — žive u susednim granama. Dok je
  // provider bio pod `UserGUI`, one do njega nisu mogle da dođu, pa keš nije
  // imao kako da bude poništen i broj je stajao star do `F5`.
  return (
    <CompositionsContextProvider>
      <MemoryContextProvider>
        <div className={`${styles.mainLayout} ${isDark ? "dark" : "light"}`}>
          <DatabaseStructureFetcher />
          <MainNavbar />
          <MainSidebar />
          <main className={styles.content}>
            <Outlet />
          </main>
        </div>
        <ModalRenderer />
      </MemoryContextProvider>
    </CompositionsContextProvider>
  );
};

export default MainLayout;
